export { default } from '@shikijs/langs/graphql'
